<template>
  <div id="contents">
    <div class="company-area no-top">
      <h1
        v-if="companyInfo.name"
        class="company-title"
        data-test="company-name"
      >
        {{ companyInfo.name }}
      </h1>
    </div>

    <!--/* Lプラン以外の場合、 キャッチコピー、紹介記事、紹介写真、取材レポートを掲出 */-->
    <template v-if="!isLightPlan">
      <div class="contents-inner">
        <p
          v-if="companyInfo.catchCopy"
          class="large-text taL fwB"
          data-test="catch"
        >
          {{ companyInfo.catchCopy }}
        </p>
      </div>
      <div class="contents-inner">
        <p class="taC mt15">
          <img
            v-if="companyInfo.introImage && companyInfo.introImage.id"
            class="company-img-main image-height-auto"
            :src="getPhotoUrl(companyInfo.introImage)"
            :alt="companyInfo.name"
            data-test="company-img-intro"
          >
        </p>
        <p
          v-if="companyInfo.introText"
          class="mt15 pega-pre-wrap"
          data-test="introText"
          v-text="companyInfo.introText"
        />
      </div>
      <company-preview-images-sp :company-info="companyInfo" />
      <div
        v-if="report.body"
        class="view-point"
        data-test="viewpoints"
      >
        <div
          class="view-points-icon"
          :style="`background: url(${userOfferImageUrlForSp}/ttl_view_point.png) no-repeat center; background-size: contain;`"
          data-test="viewpoints-icon"
        />
        <h2
          :style="`background: url(${userOfferImageUrlForSp}/view_point_line.png) repeat-x bottom; background-size: 6px;`"
          data-test="viewpoints-line"
        >
          女の転職！取材レポート
        </h2>
        <div
          v-if="report.name"
          class="report-title fs12 fb view-point-contents"
          data-test="viewpoints-name"
          v-text="`取材担当${report.name}より`"
        />
        <div
          class="view-point-contents pega-pre-wrap"
          data-test="viewpoints-body"
          v-text="report.body"
        />
      </div>
    </template>

    <!--/* データで見る働く環境エリア */-->
    <job-preview-data-for-company-sp
      v-if="isShowEnvironment(environment)"
      :environment="environment"
    />

    <!--/* 会社概要エリア */-->
    <job-preview-section-title-sp
      class="mt10"
      title="会社概要"
    />
    <company-preview-company-info-sp
      class="mb20"
      :company-info="companyInfo"
    />

    <!--/* 募集中の求人情報エリア */-->
    <job-preview-section-title-sp
      class="mt10"
      title="募集中の求人情報"
    />
    <div class="contents-inner">
      <p class="link-type-01 mt5">
        <a
          data-test="recruitment-job-info-text"
          :style="`background: url(${userOfferImageUrlForSp}/icon_arrow_right_red.png) no-repeat left; background-size: 8px 8px;`"
        >
          募集中の求人情報の「職種名」が表示されます。
        </a>
      </p>
    </div>

    <user-preview-menu-sp :titles="['フォトクリップ','インタビュー']" />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/company/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import CompanyPreviewImagesSp from '@/components/molecules/CompanyPreviewImagesSp'
import JobPreviewDataForCompanySp from '@/components/molecules/JobPreviewDataForCompanySp'
import JobPreviewSectionTitleSp from '@/components/atoms/JobPreviewSectionTitleSp'
import CompanyPreviewCompanyInfoSp from '@/components/organisms/CompanyPreviewCompanyInfoSp'
import UserPreviewMenuSp from '@/components/atoms/UserPreviewMenuSp'

export default {
  components: {
    CompanyPreviewImagesSp,
    JobPreviewDataForCompanySp,
    JobPreviewSectionTitleSp,
    CompanyPreviewCompanyInfoSp,
    UserPreviewMenuSp
  },
  mixins: [jobPreviewCommon],
  props: {
    isLightPlan: {
      type: Boolean,
      default: false
    },
    companyInfo: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: true
    },
    environment: {
      type: Object,
      required: true
    }
  }
}
</script>
